import { useEffect } from 'react';
import { haptic } from './useHaptic';

/**
 * GlobalHaptic — a top-level side effect that fires a light haptic tap on
 * every button/link click. It skips elements marked `data-no-haptic` or
 * inside form fields. Mount once at the App root.
 */
export default function useGlobalHapticOnce() {
  useEffect(() => {
    const onClick = (e) => {
      const el = e.target?.closest('button, [role="button"], a');
      if (!el) return;
      if (el.disabled) return;
      if (el.dataset?.noHaptic === 'true') return;
      // Different haptic weight for destructive / save buttons
      const kind = el.dataset?.haptic || 'tap';
      haptic(kind);
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);
}
